// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"41":"2dfdbbe4158c22675c45","524":"6dff8890ef8d9bd324a7"}[chunkId] + ".css";
};